
// import moment from 'moment-timezone'

const MONTH = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฏาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"]
const SHORT_MONTH = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."]

export const dateConvert = (dateString) => {
  if (!dateString) {
    return new Date()
  }

  return new Date(timeStampConvert(dateString))
}

export const dateFormat = (dateString) => {
  var a = dateString.split(" ");
  var d = a[0].split("-");

  if (a[1]) {
    var t = a[1].split(":");
  }

  return t ? `${d[2]} ${SHORT_MONTH[d[1] - 1]} ${parseInt(d[0]) + 543} | ${t[0]}:${t[1]}:${t[2]}`
    : `${d[2]} ${SHORT_MONTH[d[1] - 1]} ${parseInt(d[0]) + 543}`
}

export const dateOnlyFormat = (dateString) => {
  var a = dateString.split(" ");
  var d = a[0].split("-");

  if (a[1]) {
    var t = a[1].split(":");
  }

  return t ? `${d[2]} ${SHORT_MONTH[d[1] - 1]} ${parseInt(d[0]) + 543}`
    : `${d[2]} ${SHORT_MONTH[d[1] - 1]} ${parseInt(d[0]) + 543}`
}

export const dateFormatDisplay = (dateString, val) => {
  const prefix = val || '/'
  var a = dateString.split(" ");
  var d = a[0].split("-");

  return `${d[2]}${prefix}${d[1]}${prefix}${d[0]}`
}

export const timeStampConvert = (dateString) => {
  if (!dateString) {
    return 0
  }
  // moment.tz.setDefault("Asia/Bangkok")
  // let result = moment(dateString).utcOffset(7).unix();     
  // console.log(result*1000)
  // console.log(Date.parse(dateString.replace(" ","T")+'.000+07:00'))
  return Date.parse(dateString.replace(" ", "T") + '.000+07:00')
  // return Date.parse(result)
}

export const getTime = (value) => {
  const days = Math.floor(value / (24 * 60 * 60));
  const hours = Math.floor((value % (24 * 60 * 60)) / (60 * 60));
  const minutes = Math.floor((value % (60 * 60)) / 60);
  const seconds = Math.floor(value % 60);

  const formattedDays = days > 0 ? days + 'วัน ' : '';
  const formattedHours = hours < 10 ? '0' + hours : hours;
  const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
  const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

  return formattedDays + formattedHours + ':' + formattedMinutes + ':' + formattedSeconds;
}

export const getMinuteTime = (value) => {
  var minutes = Math.floor((value % (60 * 60)) / 60);
  minutes < 10 ? minutes = '0' + minutes : ''
  var seconds = Math.floor((value % 60));
  seconds < 10 ? seconds = '0' + seconds : ''
  return minutes + ':' + seconds
}

export const timeRemain = (value) => {
  return (value - Date.now()) / 1000
}

export const getMonth = (id) => {
  return MONTH[id]
}

export const getShortMonth = (id) => {
  return SHORT_MONTH[id]
}

export const getIsoDateFormat = () => {
  var now = new Date(Date.now())
  var y = now.getFullYear()
  var m = now.getMonth() + 1 > 9 ? now.getMonth() + 1 : `0${now.getMonth() + 1}`
  var d = now.getDate() > 9 ? now.getDate() : `0${now.getDate()}`
  //output format yyyy-mm-dd
  return `${y}-${m}-${d}`
}

export const getPastDate = (daysAgo) => {
  const now = new Date();
  now.setDate(now.getDate() - daysAgo);
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const firstlastMonth = (timeStamp) => {
  var date = new Date(timeStamp), y = date.getFullYear(), m = date.getMonth();
  m = m > 8 ? m + 1 : `0${m + 1}`
  var firstDay = `${y}-${m}-01`
  var dateLast = new Date(y, m, 0).getDate()
  var lastDay = `${y}-${m}-${dateLast}`

  dateLast = dateLast > 9 ? dateLast : `0${dateLast}`
  //output format [yyyy-mm-dd,yyyy-mm-dd]
  return [firstDay, lastDay]
}
export const firstLastWeek = (timeStamp) => {
  var date = timeStamp ? new Date(timeStamp) : new Date()
  var yFirst = new Date(date.setDate(date.getDate() - date.getDay()));
  var mFirst = yFirst.getMonth() + 1 > 9 ? yFirst.getMonth() + 1 : `0${yFirst.getMonth() + 1}`
  var dFirst = yFirst.getDate() > 9 ? yFirst.getDate() : `0${yFirst.getDate()}`
  var firstDay = `${yFirst.getFullYear()}-${mFirst}-${dFirst}`

  var yLast = new Date(date.setDate(date.getDate() - date.getDay() + 6));
  var mLast = yLast.getMonth() + 1 > 9 ? yLast.getMonth() + 1 : `0${yLast.getMonth() + 1}`
  var dLast = yLast.getDate() > 9 ? yLast.getDate() : `0${yLast.getDate()}`
  var lastDay = `${yLast.getFullYear()}-${mLast}-${dLast}`
  //output format [yyyy-mm-dd,yyyy-mm-dd]
  return [firstDay, lastDay]
}

function dateToIso
  (date) {
  let mLast = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`
  let dLast = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`
  return `${date.getFullYear()}-${mLast}-${dLast}`
}

export const convertDateToISO = dateToIso

export const timeStampToPreviousOneDayDate = (timeStamp) => {
  if (!timeStamp) return
  let date = new Date(timeStamp)
  date = new Date(date.setDate(date.getDate() - 1));
  return dateToIso(date)
}

export const datePreviousOneWeekDate = (val) => {
  let date = val
  date = new Date(date.setDate(date.getDate() - 7));
  return dateToIso(date)
}